import { createContext, useState } from 'react';
import Cookies from 'js-cookie';
import { LOGIN } from '../helpers/requests';

const AuthContext = createContext(null);

const AuthProvider = ({children}) => {

    const [userData, setUserData] = useState({})

    const signin = async (data, fc) => {

        let rs = await LOGIN(data)

        setUserData(rs)
        
        if (rs){
            Cookies.set('token', rs)
            fc()

        } else {
            if (Cookies.get('token')) {
                Cookies.remove('token')
            }

        }
    }

    const signout = (fc) => {
        setUserData({});
        if (Cookies.get('token')) {
            Cookies.remove('token')
        }
        fc();
    }

    const value = {userData, signin, signout};

    return <AuthContext.Provider value={value}>
        {children}
    </AuthContext.Provider>
}


export {AuthProvider, AuthContext}